import { useCallback, useRef } from 'react';
import { FetchMoreQueryOptions } from '@apollo/client';
import { useQuery } from '@apollo/client/react';
import useBugsnagNotifier from './useBugsnagNotifier';
import { featuredItemsRowQuery } from '../api/queries';
import { FeaturedItemsRowQuery } from '../graphql/graphql';
import { ITEMS_LIMIT } from '../utils/constants/homePage';

export function useFeaturedItems() {
  const receivedItems = useRef(ITEMS_LIMIT);

  const { loading, data, error, fetchMore, refetch } =
    useQuery<FeaturedItemsRowQuery>(featuredItemsRowQuery, {
      variables: {
        limit: ITEMS_LIMIT,
        offset: 0
      }
    });

  const items = data?.featuredItems || [];

  const onLoadMore = useCallback(async () => {
    const variables = {
      limit: ITEMS_LIMIT,
      offset: data?.featuredItems?.length || 0
    };

    fetchMore<FeaturedItemsRowQuery>({
      query: featuredItemsRowQuery,
      variables,
      notifyOnNetworkStatusChange: true
    } as Partial<
      FetchMoreQueryOptions<typeof variables, FeaturedItemsRowQuery>
    >).then(fetchMoreResult => {
      receivedItems.current = fetchMoreResult.data.featuredItems.length;
    });
  }, [data?.featuredItems?.length, fetchMore]);

  useBugsnagNotifier(error);

  return {
    items,
    loading,
    error,
    onLoadMore,
    refetch,
    isStopLoad: receivedItems.current < ITEMS_LIMIT
  };
}
